import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";
import { Container, PageTitle } from "./styles"
import { MENU_SETTINGS } from "../../../@enums";

//icons
import { MdOutlineAssignment, MdOutlineIntegrationInstructions, MdOutlineMonetizationOn, MdOutlineNotifications, MdOutlinePrivacyTip, MdOutlineReceipt } from "react-icons/md";
import { Integrations } from "./components/integrations";
import { Notifications } from "./components/notifications";
import { Plans } from "./components/plans";
import { Privacy } from "./components/privacy";
import { Terms } from "./components/terms";
import UsuarioContext from "../../../../context/userContext/context";
import { Pricing } from "./components/pricing";

export const Settings = (): JSX.Element => {
    const { t: translation } = useTranslation();
    const { user } = useContext(UsuarioContext);

    const query = new URLSearchParams(window.location.search);
    const pricingTab = query.get('pricingTab');

    const [menuSelected, setMenuSelected] = useState<number>(pricingTab ? MENU_SETTINGS.pricing : MENU_SETTINGS.integrations)

    return (
        <Container>
            <PageTitle >
                <h4 className="text-darker-grey"><b>{translation('manager.menu.config')}</b></h4>
            </PageTitle>

            <Row >
                <Col xs={12} lg={3} xxl={2} className="px-4 mt-4">
                    {
                        !user.is_superuser && user.profile_status === 'Parceiro' ? (
                            <>
                                <div className={`${menuSelected === MENU_SETTINGS.integrations ? "item-menu-configs-selected" : "item-menu-configs"} p-2 mb-2`} onClick={() => setMenuSelected(MENU_SETTINGS.integrations)}>
                                    <MdOutlineIntegrationInstructions className="ml-2 mr-1" size="21" /> {translation('manager.settings.integration')}
                                </div>
                                <div className={`${menuSelected === MENU_SETTINGS.pricing ? "item-menu-configs-selected" : "item-menu-configs"} p-2 mb-3`} onClick={() => setMenuSelected(MENU_SETTINGS.pricing)}>
                                    <MdOutlineReceipt className="ml-2 mr-1" size="21" /> {translation('manager.settings.pricing')}
                                </div>

                            </>
                        ) : (
                            <>
                                <div className={`${menuSelected === MENU_SETTINGS.integrations ? "item-menu-configs-selected" : "item-menu-configs"} p-2 mb-2`} onClick={() => setMenuSelected(MENU_SETTINGS.integrations)}>
                                    <MdOutlineIntegrationInstructions className="ml-2 mr-1" size="21" /> {translation('manager.settings.integration')}
                                </div>
                                <div className={`${menuSelected === MENU_SETTINGS.notifications ? "item-menu-configs-selected" : "item-menu-configs"} p-2 mb-2`} onClick={() => setMenuSelected(MENU_SETTINGS.notifications)}>
                                    <MdOutlineNotifications className="ml-2 mr-1" size="21" /> {translation('manager.settings.notifications')}
                                </div>
                                <div className={`${menuSelected === MENU_SETTINGS.terms ? "item-menu-configs-selected" : "item-menu-configs"} p-2 mb-2`} onClick={() => setMenuSelected(MENU_SETTINGS.terms)}>
                                    <MdOutlineAssignment className="ml-2 mr-1" size="21" /> {translation('manager.settings.terms')}
                                </div>
                                <div className={`${menuSelected === MENU_SETTINGS.privacy ? "item-menu-configs-selected" : "item-menu-configs"} p-2 mb-2`} onClick={() => setMenuSelected(MENU_SETTINGS.privacy)}>
                                    <MdOutlinePrivacyTip className="ml-2 mr-1" size="21" /> {translation('manager.settings.privacy')}
                                </div>
                                <div className={`${menuSelected === MENU_SETTINGS.plans ? "item-menu-configs-selected" : "item-menu-configs"} p-2 mb-2`} onClick={() => setMenuSelected(MENU_SETTINGS.plans)}>
                                    <MdOutlineMonetizationOn className="ml-2 mr-1" size="21" /> {translation('manager.settings.plans')}
                                </div>
                                <div className={`${menuSelected === MENU_SETTINGS.pricing ? "item-menu-configs-selected" : "item-menu-configs"} p-2 mb-3`} onClick={() => setMenuSelected(MENU_SETTINGS.pricing)}>
                                    <MdOutlineReceipt className="ml-2 mr-1" size="21" /> Precificação
                                </div>

                            </>
                        )
                    }
                </Col>
                <Col className="bg-config p-0">
                    {
                        menuSelected === MENU_SETTINGS.integrations && (
                            <Integrations />
                        )
                    }

                    {
                        menuSelected === MENU_SETTINGS.notifications && (
                            <Notifications />
                        )
                    }

                    {
                        menuSelected === MENU_SETTINGS.terms && (
                            <Terms />
                        )
                    }

                    {
                        menuSelected === MENU_SETTINGS.privacy && (
                            <Privacy />
                        )
                    }

                    {
                        menuSelected === MENU_SETTINGS.plans && (
                            <Plans />
                        )
                    }
                    {
                        menuSelected === MENU_SETTINGS.pricing && (
                            <Pricing />
                        )
                    }
                </Col>
            </Row>
        </Container>
    )
}